export default "__VITE_ASSET__06c16cb0__"